var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.eventGroups),function(eventGroup,idx){return _c('event-group-entry',{key:idx,attrs:{"event-group":eventGroup,"edit":_vm.edit,"secretary":_vm.secretary},on:{"input":function($event){return _vm.update($event,idx)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }